import axios, { AxiosResponse } from 'axios';
import { con } from '../../../application/entity/Rutas';
import { IServiceResult } from '../../Interfaces/IServiceResult';
import { ServiceResult } from './ServiceResult';

export class SVCEtapasProcesos {

    public static async ObtieneEtapaProceso(rut: number, año: number, periodo: number, codigoNegocio: number, codigoPrograma: string, codigoPlanificacionAcademica: number): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "Etapa/getEtapaProceso";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";

        await axios
            .post(url, {
                'rut': rut,
                'codigoNegocio': codigoNegocio,
                'codigoPrograma': codigoPrograma,
                'codigoPlanificacionAcademica': codigoPlanificacionAcademica
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async ObtieneSiguienteEtapa(contrato: boolean, pago: boolean): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "Etapa/getSiguienteEtapa";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";

        await axios
            .get(url,
                {
                    params: {
                        'contrato': contrato,
                        'pago': pago
                    }
                })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async ObtieneBeneficioAutomatico(headers: any,codNegocio: number, codPrograma: string): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRutaBFF();
        const url: string = _ruta + "GetBeneficioAutomaticoPorCodigoPrograma";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";

        await axios
            .get(url,
                {
                    headers,
                    params: {
                        'codNegocio': codNegocio,
                        'codPrograma': codPrograma
                    }
                })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async ObtieneBeneficioAutomaticoPorRut(codCarr: string, codigoBeneficio: number, rut: number): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRutaBeneficios();
        const url: string = _ruta + "BeneficiosComplementario/getBeneficioComplementarioPorRut";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        await axios
            .get(url,
                {
                    params: {
                        'rut': rut,
                        'beneficio': codigoBeneficio,
                        'codCarr': codCarr
                    }
                })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async ObtieneDeudaFinanciera(headers: any, rut: number): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRutaBFF();
        const url: string = _ruta + "GetDeudaFinancieraPorRut";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";

        await axios
            .get(url,
                {
                    headers,
                    params: {
                        'rut': rut
                    }
                })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async ObtieneDeudaBiblioteca(rut: number, ano: number, periodo: number): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "Persona/getDeudaBiblioteca";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";

        await axios
            .get(url,
                {
                    params: {
                        'rut': rut,
                        'anio': ano,
                        'periodo': periodo
                    }
                })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async ObtieneDocumentoLEM(rut: number, ano: number, periodo: number): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "Persona/getDocumentoLEM";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";

        await axios
            .get(url,
                {
                    params: {
                        'rut': rut,
                        'anio': ano,
                        'periodo': periodo
                    }
                })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async InsertPrimeraEtapaProceso(rut: number, año: number, periodo: number, codigoNegocio: number, codigoPrograma: string,
        codigoPlanificacionAcademica: number, idPeriodo: number): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "Etapa/insertPrimeraEtapaProceso";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";

        await axios
            .post(url, {
                'rut': rut,
                'ano': año,
                'periodo': periodo,
                'codigoNegocio': codigoNegocio,
                'codigoPrograma': codigoPrograma,
                'codigoPlanificacionAcademica': codigoPlanificacionAcademica,
                'idPeriodo': idPeriodo
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                    /* console.log(sr.result) */
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async InsertPrimeraEtapaProcesoFirma(rut: number, año: number, periodo: number, codigoNegocio: number, codigoPrograma: string, codigoPlanificacionAcademica: number): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "Etapa/insertPrimeraEtapaProcesoFirma";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";

        await axios
            .post(url, {
                'rut': rut,
                'ano': año,
                'periodo': periodo,
                'codigoNegocio': codigoNegocio,
                'codigoPrograma': codigoPrograma,
                'codigoPlanificacionAcademica': codigoPlanificacionAcademica
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                    /* console.log(sr.result) */
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async UpdateEtapaProceso(idProceso: number, idEtapa: number, esPregradoSinRF: boolean): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "Etapa/UpdateEtapaProceso";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";

        await axios
            .post(url, {
                "idProceso": idProceso,
                "idEtapa": idEtapa,
                "esPostgrado": esPregradoSinRF
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async ObtenerToken(rut: string, fechaNacimiento: Date): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRutaBFF();
        const url: string = _ruta + "Authentication/RutFechaNac";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        const data = {
            'rut': rut,
            'fechaNac': fechaNacimiento
        }
        await axios
            .post(url, data)
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async ObtenerTokenEmail(rut: string, correo: string): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRutaBFF();
        const url: string = _ruta + "Authentication/RutCorreoAuth";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        const data = {
            'rut': rut,
            'cuentaCorreo': correo
        }
        await axios
            .post(url, data)
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async ObtenerTokenPostDec(data:any): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRutaBFF();
        const url: string = _ruta + "Authentication/PostgradoYDec";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        await axios
            .post(url, data)
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }
    
}
